export default function SmallSourceLink({text, link}) {
  return (
    <a style={{fontSize: '10px'}} target="_blank" rel="noopener noreferrer" href={link}>
      {text}
    </a>
  );
}
